export function type(n, a) {
    return Object.assign({ "@odata.type": n }, a);
}
//# sourceMappingURL=type.js.map